"use client";

import { c as _c } from "react/compiler-runtime";
import algo from "algoliasearch/lite";
import type { SharedProps } from "fumadocs-ui/components/dialog/search";
import SearchDialog from "fumadocs-ui/components/dialog/search-algolia";
const client = algo(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!, process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY!);
const index = client.initIndex(process.env.NEXT_PUBLIC_ALGOLIA_INDEX ?? "document");
export default function AlgoliaSearchDialog(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SearchDialog index={index} {...props} showAlgolia={false} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}